import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pagination-preco',
  templateUrl: './pagination-preco.component.html',
  styleUrls: ['./pagination-preco.component.scss']
})
export class PaginationPrecoComponent implements OnInit {

  public size: number = 10;
    public pagePreco;
    @Input("pagePreco") public set value(pagePreco : any){
        if(!pagePreco) return;
        this.pagePreco = pagePreco;
        this.setPagetion();
    }
    @Output() public  paginationEvent : EventEmitter<any> = new EventEmitter();

    constructor() { }

    ngOnInit() {}

    changePage(pagePreco?){
        setTimeout(()=>{
            this.paginationEvent.emit({pagePreco: pagePreco? pagePreco : 0, size: this.size} );
            console.log(pagePreco);
        });
    }

    setPagetion(){
        let pages = new Array<number>();
        let inc =  (this.pagePreco.number - 2) <= 0 ? (4 - this.pagePreco.number) : 2;
        let dec =  (this.pagePreco.number + 2) >= this.pagePreco.totalPages ? (5 - (this.pagePreco.totalPages - this.pagePreco.number)) : 2;
        let inicio = (this.pagePreco.number - dec) <= 0 ? 0 : (this.pagePreco.number - dec);
        let fim = (this.pagePreco.number + inc) < this.pagePreco.totalPages ? (this.pagePreco.number + inc) : (this.pagePreco.totalPages - 1);
        for(let i = inicio; i<= fim; i++){
            pages.push(i);
        }
        this.pagePreco.pages = pages;
    }

}



// WEBPACK FOOTER //
// /app/src/app/components/pagination-preco/pagination-preco.component.ts